import React, { SyntheticEvent } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import $DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';

import { t } from '../../locales/i18n';
import { getLocaleDateString, getLocaleTimeString, str2time } from '../../utils/date-utils';
import { DateLocaleListener, addLocaleListener, NiQLocale } from '../../utils/date-utils';

//export const DATE_FORMAT = 'dd/MM/yyyy';
//export const TIME_FORMAT = 'HH:mm';
//export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

interface DatePickerProps {
  value?: string;
  selected?: Date | null;
  onChange: (dt: Date, e: SyntheticEvent) => void;
  timeIntervals?: number;
  showTimeSelect?: boolean;
  disabled?: boolean;
  type: 'date' | 'time' | 'datetime';
}

const onLocaleChange: DateLocaleListener = (code: string, locale: NiQLocale) => {
  const languageString = locale.locale.code ? locale.locale.code.slice(0, 2) : 'cs';

  // localization for react-datepicker
  registerLocale(languageString, locale.locale);
  setDefaultLocale(languageString);
};

addLocaleListener(onLocaleChange);

export function DatePicker(props: DatePickerProps) {
  const { onChange, value, selected, timeIntervals, disabled, type } = props;
  const showTimeSelect = type !== 'date';
  const showTimeSelectOnly = type === 'time';

  return (
    <$DatePicker
      onChange={onChange}
      value={value}
      selected={selected || str2time(value || '')}
      dateFormat={getLocaleDateString()}
      showTimeSelect={showTimeSelect}
      showTimeSelectOnly={showTimeSelectOnly}
      disabled={disabled}
      timeFormat={getLocaleTimeString()}
      timeIntervals={timeIntervals || 1}
      timeCaption={t('datePicker.timeTitle')}
    />
  );
}
